module.exports = __webpack_public_path__ + "static/media/6.b14d7bbf.svg";